<template>
    <div
        class="bg-gradient-to-br from-white to-slate-50 w-full h-3/5 lg:w-1/2 lg:h-full rounded-t-xl lg:rounded-none lg:rounded-l-xl relative">

        <!-- Preloading modal -->
        <transition name="fade">
            <SendingFormRequestModal v-if="isPreloadVisible" :phoneNumber="phone" @close="removeFormLoadingModal">
            </SendingFormRequestModal>
        </transition>

        <!-- Error modal -->
        <transition name="fade">
            <FormErrorModal v-if="modalVisible" :modalMessage="modalMessage" @close="removeFormErrorModal" :phoneNumber="phone">
            </FormErrorModal>
        </transition>


        <!-- Header Section -->
        <div class="h-2/6 w-full px-5 lg:p-5 flex flex-col justify-evenly items-start">
            <div class="w-full flex justify-start items-center">
                <img class="w-1/3" src="../assets/logo-gifty.png" alt="Gifty Logo" />
            </div>
            <div class="text-sm lg:text-lg font-medium text-gray-700 text-start">
                {{ $t('complete_purchase') }}
            </div>
        </div>

        <!-- Form Section -->
        <div class="h-4/6 w-full px-5 lg:px-5 py-1 lg:pb-5 flex-1 bg-gray-50 border-t border-gray-200 lg:rounded-l-xl">
            <form class="w-full flex flex-col justify-evenly h-full" @submit.prevent="submit">
                <div class="w-full">
                    <!-- Phone Input -->
                    <label class="block text-sm lg:text-base font-medium text-gray-700 mb-2">
                        {{ $t('phone_number') }}
                    </label>
                    <input v-model="phone" type="text" :placeholder="$t('phone_placeholder')"
                        class="w-full px-3 py-1 text-sm lg:text-base lg:py-2 border border-gray-300 bg-slate-100 rounded-md outline-none focus:ring-2 focus:ring-[#f01e6b] mb-1" />
                    <p v-if="isSubmitted && phoneError" class="text-red-500 text-xs">
                        {{ phoneError }}
                    </p>

                    <!-- Amount Input -->
                    <label class="block text-sm lg:text-base font-medium text-gray-700 mt-1 lg:mt-3 mb-2">
                        {{ $t('amount') }}
                    </label>
                    <input v-model="amount" type="number" :placeholder="$t('enter_amount')"
                        class="w-full px-3 py-1 text-sm lg:text-base lg:py-2 border border-gray-300 bg-slate-100 rounded-md outline-none focus:ring-2 focus:ring-[#f01e6b] mb-1"
                        :disabled="!isPartial" />
                    <p v-if="isSubmitted && amountError" class="text-red-500 text-xs">
                        {{ amountError }}
                    </p>
                </div>
                <div class="flex flex-col space-y-2 w-full ">
                    <!-- Submit Button -->
                    <button type="submit"
                        class="w-full bg-[#f01e6b] text-white  text-sm lg:text-base  font-medium lg:font-normal py-1 lg:py-2 rounded-md hover:bg-[#f01e6bbc] hover:cursor-pointer transition duration-200"
                        :disabled="isPreloadVisible">
                        {{ $t('submit_payment') }}
                    </button>
                    <!-- Cancel Button -->
                    <div @click="emitCancelEvent"
                        class="w-full text-center  bg-gray-400 text-white  text-sm lg:text-base  font-medium lg:font-normal py-1 lg:py-2 rounded-md hover:bg-gray-300 hover:cursor-pointer transition duration-200"
                        :disabled="isPreloadVisible">
                        {{ $t('cancel_order') }}
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';
import { storePurchaseData } from '../services/api';
import usePusher from '../services/usePusher';
import { useI18n } from 'vue-i18n';
import FormErrorModal from './Modals/FormErrorModal.vue';
import SendingFormRequestModal from './Modals/SendingFormRequestModal.vue';

const { t } = useI18n();
const emit = defineEmits(['showGapp', 'hideGapp', 'transactionRespond', 'showCancelModal']);
const props = defineProps({
    amount: Number,
    isPartial: Number,
    keyItem: String,
    redirectUrl: String
});

const redirectUrl = ref(props.redirectUrl || '');

//Validation 

const phone = ref('');
const amount = ref(props.amount || '');
const isSubmitted = ref(false);

const phoneError = computed(() => {
    if (!phone.value) return "Phone number is required.";
    if (!/^(05|06|07)\d{8}$/.test(phone.value)) return "Invalid Algerian phone number format.";
    return "";
});

const amountError = computed(() => {
    if (!amount.value || amount.value <= 0) return "Amount must be greater than 0.";
    return "";
});

const isFormValid = computed(() => !phoneError.value && !amountError.value);

watch(() => props.amount, (newAmount) => {
    amount.value = newAmount;
}, { immediate: true });


//Modals 

// Form Submition Modals 
// # Error Modal
const modalVisible = ref(false);
const modalMessage = ref('');
const removeFormErrorModal = () => {
    modalVisible.value = false;
}
// # Loading Modal
const isPreloadVisible = ref(false);
const removeFormLoadingModal = () => {
    isPreloadVisible.value = false;
}

const showPusherModal = (type) => {
    emit('hideGapp');
    emit('transactionRespond', type);

    setTimeout(() => {
        window.location.href = redirectUrl.value;
    }, 4000);


}


const emitCancelEvent = () => {
    emit('showCancelModal');
}

const channel_id = ref("");

//Form 

const submit = () => {
    isSubmitted.value = true;
    if (!isFormValid.value) return;

    isPreloadVisible.value = true;
    setTimeout(async () => {
        sendFormRequest();
        isPreloadVisible.value = false;
    }, 3000);


};

const sendFormRequest = async () => {
    if (isPreloadVisible.value) {
        try {
            channel_id.value = Math.random().toString(36).substring(2, 2 + 16);

            const tokenKey = window.location.pathname.split('/').pop();

            const response = await storePurchaseData({ channel_id: channel_id.value, key: tokenKey, phone: "+213" + phone.value.slice(1), amount: amount.value });


            console.log('response :>> ', response);


            if (response?.status === 200 || response?.status === 201) {

                emit('showGapp');
                usePusher(channel_id.value, showPusherModal);

            } else {
                modalMessage.value = t("unsuccesfull_payment") + " " + (response?.data?.message ?? "");
                modalVisible.value = true;
            }
        } catch (e) {
            console.log('################# :>> ', e.response.data.message);

            modalMessage.value = t("unsuccesfull_payment") + " " + (e.response?.data?.message ?? "");
            modalVisible.value = true;
        }
    }
}

</script>

<style scoped>
/* Loading transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Spinner animation */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>
